import { Button, Snackbar } from '@mui/material';
import { UNDO_SECONDS } from './pendingCompletion';
import { pendingCompletions } from './taskCompletions';

/** The drawer's messages, and Undo after a Complete. */
const TaskSnackbar = ({ snack, setSnack }) => (
    <Snackbar
        open={!!snack}
        autoHideDuration={snack?.undoTaskIds ? UNDO_SECONDS * 1000 : 6000}
        onClose={(_, reason) => reason !== 'clickaway' && setSnack(null)}
        message={snack?.message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        ContentProps={{ sx: snack?.error ? { backgroundColor: 'error.main' } : undefined }}
        action={
            snack?.undoTaskIds ? (
                <Button
                    color="secondary"
                    size="small"
                    onClick={() => {
                        pendingCompletions.undoMany(snack.undoTaskIds);
                        setSnack({ message: 'Undone' });
                    }}
                >
                    Undo
                </Button>
            ) : undefined
        }
    />
);

export default TaskSnackbar;
